import { ScrollConfig } from '../../../models';
import { DeepPartial } from '../../../utils';

export const DEFAULT_SCROLL_CONFIG: DeepPartial<ScrollConfig> = {
  scrollPanelSelector: '.ebx-empathy-x__main'
};
